import React from 'react';

const SocketContext = React.createContext(null);

export default SocketContext;